export default __webpack_public_path__ + "static/lp-bodyareas-transparent-ef7d97f57b2ff1dd7a145871fda93285.png";